import React, { ComponentProps } from 'react';

import Checkbox from '@atlaskit/checkbox';
import { components } from '@atlaskit/select';

import { TextWithSubtext } from '../TextWithSubtext';
import {
  CheckboxStyled,
  WrapperStyled,
} from './OptionWithCheckboxAndSubtext.styled';

type Props = {
  text: string;
  subtext: string;
  isChecked: boolean;
  optionProps: ComponentProps<typeof components.Option>;
};

export function OptionWithCheckboxAndSubtext({
  text,
  subtext,
  isChecked,
  optionProps,
}: Props): JSX.Element {
  return (
    <components.Option {...optionProps}>
      <WrapperStyled>
        <CheckboxStyled>
          <Checkbox isChecked={isChecked} />
        </CheckboxStyled>
        <TextWithSubtext text={text} subtext={subtext} />
      </WrapperStyled>
    </components.Option>
  );
}
